module.exports = __webpack_public_path__ + "img/book_1920.62bbaa29.png";